import {
  Button,
  useRecordContext,
  useResourceContext,
  useRedirect,
} from "react-admin";
import IconDetails from "@mui/icons-material/Visibility";

function ButtonDetails()
{
  const record = useRecordContext();
  const resource = useResourceContext();
  const redirect = useRedirect();

  const btnClick = (e) =>
  {
    e.stopPropagation();

    redirect("/" + resource + "/" + record.id + "/show");
  };

  return (
    <Button onClick={btnClick} label="Detalhes">
      <IconDetails />
    </Button>
  );
}

export default ButtonDetails;
